module.exports = __webpack_public_path__ + "static/img/XA50.e6bbc46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XA50.png
// module id = Qpv9
// module chunks = 2